import {useRef, memo} from 'react';

import * as store from '@/store';

export * from './Header';
import Header, {ISlots} from './Header';
import {
    useAdapter,
    IAdapterData,
} from './Header/widthAdapter';

import styles from './index.module.scss';

interface IProps {
    headerSlot?: ISlots | null;
    headerAdapterData?: IAdapterData;
}

const Head: React.FC<IProps> = ({headerSlot, headerAdapterData}) => {
    const wrapElRef = useRef<HTMLDivElement | null>(null);
    const headerElRef = useRef<HTMLDivElement | null>(null);
    useAdapter(wrapElRef, headerElRef);

    return (
        <div className={styles.wrap} ref={wrapElRef}>
            <Header headerSlot={headerSlot} headerAdapterData={headerAdapterData} />
        </div>
    );
};

const HeadImpl = store.connect([
    store.KEYS.HEADER_ADAPTER_DATA,
])(Head);

export default memo(HeadImpl);
